import * as React from "react";
import DatacentersListMain from "../components/datacenters-list/DatacentersListMain";


export interface DatacenterListPageProps {}

const DatacenterListPage: React.FC<DatacenterListPageProps> = () => {
  


  return (
    <React.Fragment>
      <DatacentersListMain />
    </React.Fragment>
  );
};

export default DatacenterListPage;
